module.exports = __webpack_public_path__ + "static/media/40.9274f925.png";